import { render } from "./InOnLaysCare.vue?vue&type=template&id=99be9d14"
import script from "./InOnLaysCare.vue?vue&type=script&lang=js"
export * from "./InOnLaysCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__